<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <el-table
      :data="list"
      v-loading="listLoading"
      style="width: 100%"
      ref="table"
      class="custom-tbl"
    >
      <el-table-column type="selection" width="60"></el-table-column>
      <el-table-column label="序号" type="index" width="60"></el-table-column>
      <el-table-column
        label="赛事名称"
        prop="Name"
        width="120"
      ></el-table-column>
      <el-table-column
        label="赛事简介"
        prop="Desc"
        width="240"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="标签" prop="Tag" width="120"></el-table-column>
      <el-table-column label="赛程表" prop="Schedule" width="120">
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            :src="scope.row.Schedule"
            fit="cover"
            :preview-src-list="[scope.row.Schedule]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        label="距离"
        prop="Distance"
        width="80"
      ></el-table-column>
      <el-table-column
        label="赛场地址"
        prop="Adress"
        width="120"
      ></el-table-column>
      <el-table-column
        label="赛场详细地址"
        prop="AdressDetail"
        width="120"
      ></el-table-column>
      <el-table-column
        label="开始时间"
        prop="StartTime"
        width="120"
      ></el-table-column>
      <el-table-column
        label="结束时间"
        prop="EndTime"
        width="120"
      ></el-table-column>
      <el-table-column label="价格" prop="Price" width="100"></el-table-column>
      <el-table-column label="封面图片">
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            :src="scope.row.CroverImage"
            fit="cover"
            :preview-src-list="[scope.row.CroverImage]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button type="danger" size="mini" @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="mt16">
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
    <!-- 新增赛事 -->
    <el-dialog
      :title="dialogStatus === 'add' ? '新增赛事' : '编辑赛事'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="80%"
      append-to-body
      @closed="resetForm"
    >
      <el-form
        :model="formData"
        label-width="120px"
        :rules="formRules"
        ref="dataForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card shadow="never">
              <div slot="header">
                <span>基本信息</span>
              </div>
              <el-form-item label="名称" prop="Name">
                <el-input
                  v-model="formData.Name"
                  placeholder="请输入赛事名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="赛事简介" prop="Desc">
                <el-input
                  v-model="formData.Desc"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入赛事简介"
                ></el-input>
              </el-form-item>
              <el-form-item label="标签" prop="Tag">
                <el-input
                  v-model="formData.Tag"
                  placeholder="请输入标签"
                ></el-input>
              </el-form-item>
              <el-form-item label="距离" prop="Distance">
                <el-input
                  v-model="formData.Distance"
                  placeholder="请输入距离"
                ></el-input>
              </el-form-item>
            </el-card>
          </el-col>

          <el-col :span="12">
            <el-card shadow="never">
              <div slot="header">
                <span>时间与价格</span>
              </div>
              <el-form-item label="开始时间" prop="StartTime">
                <el-date-picker
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择开始时间"
                  v-model="formData.StartTime"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间" prop="EndTime">
                <el-date-picker
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择结束时间"
                  v-model="formData.EndTime"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="价格" prop="Price">
                <el-input-number
                  v-model="formData.Price"
                  :min="0"
                  :step="0.01"
                  style="width: 100%"
                ></el-input-number>
              </el-form-item>
            </el-card>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="mt20">
          <el-col :span="12">
            <el-card shadow="never">
              <div slot="header">
                <span>地址信息</span>
              </div>
              <el-form-item label="赛场地址" prop="Adress">
                <el-input
                  v-model="formData.Adress"
                  placeholder="请输入赛场地址"
                ></el-input>
              </el-form-item>
              <el-form-item label="详细地址" prop="AdressDetail">
                <el-input
                  v-model="formData.AdressDetail"
                  placeholder="请输入详细地址"
                ></el-input>
              </el-form-item>
            </el-card>
          </el-col>

          <el-col :span="12">
            <el-card shadow="never">
              <div slot="header">
                <span>其他设置</span>
              </div>
              <el-form-item label="购票须知" prop="TicketPurchaseNotice">
                <el-input
                  v-model="formData.TicketPurchaseNotice"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入购票须知"
                ></el-input>
              </el-form-item>
              <el-form-item label="观演须知" prop="ObservationNotice">
                <el-input
                  v-model="formData.ObservationNotice"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入观演须知"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否热门" prop="IsHot">
                <el-switch v-model="formData.IsHot"></el-switch>
              </el-form-item>
            </el-card>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="mt20">
          <el-col :span="24">
            <el-card shadow="never">
              <div slot="header">
                <span>图片信息</span>
              </div>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="封面图片" prop="CroverImage">
                    <Upload
                      @upload="handleUpload"
                      @delete="handleDelete"
                      :fileUrl="formData.CroverImage"
                      type="match"
                    ></Upload>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="赛程表" prop="Schedule">
                    <Upload
                      @upload="uploadSchedule"
                      @delete="deleteSchedule"
                      :fileUrl="formData.Schedule"
                      type="match"
                    ></Upload>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="赛事图片">
                    <UploadArr
                      @upload="uploadMatch"
                      @delete="uploadMatch"
                      :fileUrlArr="formData.fileUrlArr"
                      type="match"
                    ></UploadArr>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>
<script>
import util from "../../../util/date";
import {
  matchList,
  addMatch,
  updateMatch,
  matchDetail,
  deleteMatch,
} from "@/api/match/match";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Upload from "@/components/Upload.vue";
import UploadArr from "@/components/uploadImgArr.vue";
export default {
  components: { Toolbar, Upload, UploadArr },
  data() {
    return {
      filters: {},
      buttonList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      listLoading: false,
      total: 0,
      dialogVisible: false,
      dialogStatus: "add",
      submitLoading: false,
      formData: {},
      formRules: {
        Name: [{ required: true, message: "请输入赛事名称", trigger: "blur" }],
        StartTime: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        EndTime: [
          { required: true, message: "请选择结束时间", trigger: "change" },
        ],
        Adress: [
          { required: true, message: "请输入赛场地址", trigger: "blur" },
        ],
        CroverImage: [
          { required: true, message: "请上传封面图片", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
  },
  methods: {
    callFunction(name) {
      this.$router.push({ name: name });
    },
    uploadMatch(e) {
      try {
        this.formData.fileUrlArr = [];
        this.formData.MatchImage = [];

        if (!e || !Array.isArray(e) || e.length === 0) {
          return;
        }

        const validImages = e.filter(
          (url) => typeof url === "string" && url.trim() !== ""
        );

        this.formData.fileUrlArr = validImages;

        if (this.dialogStatus === "add") {
          this.formData.MatchImage = validImages.map((url) => ({
            ImageAdress: url.trim(),
            ImageTpye: 2,
            MatchId: null,
            Id: null,
          }));
        } else {
          const existingImages = this.formData.MatchImages || [];

          this.formData.MatchImage = validImages.map((url) => {
            const existingImage = existingImages.find(
              (img) => img && img.ImageAdress === url.trim()
            );

            if (existingImage) {
              return {
                ...existingImage,
                ImageTpye: 2,
              };
            }

            return {
              ImageAdress: url.trim(),
              ImageTpye: 2,
              MatchId: this.formData.Id || null,
              Id: null,
            };
          });
        }

        if (!Array.isArray(this.formData.MatchImage)) {
          throw new Error("图片数据处理异常");
        }

        this.formData.MatchImage = this.formData.MatchImage.map((item) => ({
          ImageAdress: item.ImageAdress || "",
          ImageTpye: item.ImageTpye || 2,
          MatchId: item.MatchId || null,
          Id: item.Id || null,
        }));
      } catch (error) {
        console.error("uploadMatch error:", error);
        this.$message.error("图片处理失败，请重试");
        this.formData.fileUrlArr = [];
        this.formData.MatchImage = [];
      }
    },
    handleDel(row) {
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleteMatch({
          id: row.Id,
        }).then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          }
        });
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    uploadSchedule(e) {
      this.formData.Schedule = String(e || "");
    },
    deleteSchedule() {
      this.formData.Schedule = "";
    },
    handleAdd() {
      this.dialogStatus = "add";
      this.resetForm();
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },
    handleEdit(row) {
      if (!row || !row.Id) {
        this.$message.error("无效的数据");
        return;
      }

      try {
        this.dialogStatus = "edit";
        this.resetForm();

        this.$nextTick(() => {
          matchDetail({ id: row.Id })
            .then((res) => {
              if (!res || !res.data || !res.data.response) {
                throw new Error("获取数据失败");
              }

              const response = res.data.response;

              this.formData = {
                ...this.getInitialFormData(),
                ...response,
                MatchImage: [],
                fileUrlArr: [],
                MatchImages: [],
              };

              if (Array.isArray(response.MatchImages)) {
                const validImages = response.MatchImages.filter(function (
                  item
                ) {
                  return item && item.ImageAdress;
                });

                this.formData.MatchImages = [...validImages];
                this.formData.fileUrlArr = validImages.map(function (item) {
                  return item.ImageAdress;
                });
                this.formData.MatchImage = validImages.map(function (item) {
                  return {
                    Id: item.Id,
                    MatchId: item.MatchId,
                    ImageAdress: item.ImageAdress,
                    ImageTpye: item.ImageTpye || 2,
                  };
                });
              }

              this.$nextTick(() => {
                this.dialogVisible = true;
              });
            })
            .catch((error) => {
              console.error("handleEdit error:", error);
              this.$message.error(error.message || "获取数据失败，请重试");
            });
        });
      } catch (error) {
        console.error("handleEdit outer error:", error);
        this.$message.error("处理数据失败，请重试");
      }
    },
    submitForm() {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return;
        }

        try {
          this.submitLoading = true;
          const submitData = Object.assign({}, this.formData);

          if (!submitData.Name || submitData.Name.trim() === "") {
            throw new Error("请输入赛事名称");
          }
          if (!submitData.StartTime || !submitData.EndTime) {
            throw new Error("请选择比赛时间");
          }
          if (!submitData.CroverImage) {
            throw new Error("请上传封面图片");
          }

          const startTime = new Date(submitData.StartTime);
          const endTime = new Date(submitData.EndTime);
          if (endTime <= startTime) {
            throw new Error("结束时间必须大于开始时间");
          }

          submitData.MatchImage = Array.isArray(submitData.MatchImage)
            ? submitData.MatchImage
            : [];

          if (this.dialogStatus === "edit" && submitData.Id) {
            submitData.MatchImage = submitData.MatchImage.map(function (item) {
              return {
                ...item,
                MatchId: submitData.Id,
              };
            });
          }

          delete submitData.MatchImages;
          delete submitData.fileUrlArr;

          const submitMethod =
            this.dialogStatus === "add" ? addMatch : updateMatch;

          submitMethod(submitData)
            .then((res) => {
              if (!res || !res.data || !res.data.success) {
                throw new Error(
                  (res && res.data && res.data.msg) || "操作失败"
                );
              }
              this.$message.success((res.data && res.data.msg) || "操作成功");
              this.closeDialog();
              this.getList();
            })
            .catch((error) => {
              throw error;
            });
        } catch (error) {
          console.error("submitForm error:", error);
          this.$message.error(error.message || "提交失败，请重试");
        } finally {
          this.submitLoading = false;
        }
      });
    },
    handleUpload(e) {
      this.formData.CroverImage = String(e || "");
    },
    handleDelete() {
      this.formData.CroverImage = "";
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.filters = {
        name: "",
      };
    },
    getList() {
      let para = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
      };
      this.listLoading = true;

      matchList(para)
        .then((res) => {
          this.total = res.data.response.dataCount;
          this.list = res.data.response.data;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    resetForm() {
      try {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.resetFields();
        }
        this.formData = this.getInitialFormData();

        this.$nextTick(() => {
          const uploadComponents =
            this.$refs.dataForm.$el.querySelectorAll(".el-upload");
          uploadComponents.forEach((upload) => {
            const uploadInstance = upload.__vue__;
            if (uploadInstance && uploadInstance.clearFiles) {
              uploadInstance.clearFiles();
            }
          });

          this.formData.CroverImage = "";
          this.formData.Schedule = "";
          this.formData.MatchImage = [];
          this.formData.fileUrlArr = [];
          this.formData.MatchImages = [];

          this.$forceUpdate();
        });
      } catch (error) {
        console.error("resetForm error:", error);
        this.formData = {
          ...this.getInitialFormData(),
          CroverImage: "",
          Schedule: "",
          MatchImage: [],
          fileUrlArr: [],
          MatchImages: [],
        };
      }
    },
    closeDialog() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 300);
    },
    getInitialFormData() {
      return {
        Name: "",
        Desc: "",
        Tag: "",
        Distance: "",
        StartTime: "",
        EndTime: "",
        Price: 0,
        Adress: "",
        AdressDetail: "",
        TicketPurchaseNotice: "",
        ObservationNotice: "",
        IsHot: false,
        CroverImage: "",
        Schedule: "",
        MatchImage: [],
        fileUrlArr: [],
        MatchImages: [],
      };
    },
    validateImageData(imageData) {
      if (!imageData || typeof imageData !== "object") {
        return false;
      }
      return (
        typeof imageData.ImageAdress === "string" &&
        typeof imageData.ImageTpye === "number"
      );
    },
  },
};
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
